// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"132":"confirm-interest","207":"safety-handbbok","254":"procurement-post","389":"404","654":"supplier-responsibility","712":"apply-procurement","871":"procurement"}[chunkId] + "." + {"132":"503a3644","207":"d6384860","254":"5680ac74","389":"d3e7fc0c","654":"43152dfd","712":"e058e663","871":"d1387410"}[chunkId] + ".js";
};